import { useEffect, useRef } from 'react';
import useSSOPlatforms from '../../integrations/useSSOPlatforms';
import useIsPasswordSet from '../useIsPasswordSet';
import OrganizationOnboardingModal, {
  AUTHENTICATION_STEP,
  INVITE_STEP,
} from './OrganizationOnboardingModal';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { UIActions } from '../../ui/uiSlice';

interface OrganizationOnboardingContainerProps {
  onComplete: () => void;
  onSkip: () => void;
  onUpdateStep: (step: number) => void;
  onboarding?: { step: number };
}

const OrganizationOnboardingContainer = (
  props: OrganizationOnboardingContainerProps,
) => {
  const dispatch = useAppDispatch();
  const ssoPlatforms = useSSOPlatforms() || [];
  const initialStepSetRef = useRef(false);
  const {
    onboarding: { step = 0 } = {},
    onUpdateStep,
    onComplete,
    onSkip,
  } = props;

  const { loading, data: isPasswordSet } = useIsPasswordSet();
  const canUserLogIn = ssoPlatforms.length > 0 || isPasswordSet === true;
  const initialStep = canUserLogIn ? INVITE_STEP : AUTHENTICATION_STEP;

  useEffect(() => {
    if (!loading && !initialStepSetRef.current) {
      if (initialStep > step) {
        onUpdateStep(initialStep);
      }

      initialStepSetRef.current = true;
    }
  }, [loading, initialStep, onUpdateStep, step]);

  useEffect(() => {
    if (initialStepSetRef.current) {
      dispatch(
        UIActions.openModal(OrganizationOnboardingModal, {
          disableOutsideClose: true,
          step,
          onComplete,
          onSkip,
          onUpdateStep,
        }),
      );
    }
  });

  useEffect(
    () => () => {
      dispatch(UIActions.closeModal());
    },
    [dispatch],
  );

  return null;
};

export default OrganizationOnboardingContainer;
